<template>
  <v-card outlined class="h100 card-height">
    <v-list-item three-line>
      <v-list-item-content>
        <div class="mb-4">
          {{ typeDocument | typedocument }}
        </div>
        <v-list-item-title class="text-h6 mb-1">
          <span v-if="nomDocument">
            {{ nomDocument }}
          </span>
          <span v-else> &nbsp; </span>
        </v-list-item-title>
        <v-list-item-subtitle>
          <span v-if="tailleDocument">
            {{ tailleDocument | bytes }}
          </span>
          <span v-else> &nbsp; </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="journal">
          <span>
            Journal d'annonces légales : <strong>{{ journal }}</strong>
          </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          <span v-if="dateDocument">
            {{ typeDocument | libelledatedocument }} :
            <strong>{{ dateDocument | date }}</strong>
          </span>
          <span v-else> &nbsp; </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          <span v-if="sousType">
            Sous-type : <strong>{{ sousType | soustypedocument }}</strong>
          </span>
          <span v-else-if="dateEffet">
            {{ typeDocument | libelledateeffet }} :
            <strong>{{ dateEffet | date }}</strong>
          </span>
          <span v-else> &nbsp; </span>
        </v-list-item-subtitle>
        <a-plain-text-component :rules="[serverRule(`documents[${index}]`)]" />
      </v-list-item-content>
      <div class="actions-icons">
        <template v-if="telechargeable">
          <a-tooltip-icon-button
            icon="mdi-eye"
            tooltip="Consulter le document"
            :loading="telechargement"
            @click="telecharge"
            data-testid="consulter-document"
          />
        </template>
        <template v-if="actionsPossible">
          <a-tooltip-icon-button
            icon="mdi-delete"
            tooltip="Supprimer le document"
            @click="supprimer"
            data-testid="supprimer-document"
          />
        </template>
      </div>

      <div class="stamp">
        <a-ajoute-teleservice-stamp v-if="issuTeleservice" />
      </div>
    </v-list-item>
  </v-card>
</template>

<script>
import { documentService } from "@/services";
import makeRules from "@/mixins/makeRules";
export default {
  mixins: [makeRules()],
  props: {
    value: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      telechargement: false,
    };
  },

  methods: {
    supprimer() {
      this.$emit("supprimer", this.value);
    },
    telecharge() {
      if (this.$listeners.telecharge) {
        this.$emit("telecharge", this.value);
        return;
      }

      this.telechargement = true;
      documentService
        .telechargeBlob(this.value.nom, this.value.lien)
        .finally(() => (this.telechargement = false));
    },
  },

  computed: {
    actionsPossible() {
      return this.value.actionsPossible;
    },
    telechargeable() {
      return !!this.value.lien || !!this.value.fichier;
    },
    tailleDocument() {
      return this.value.taille;
    },
    nomDocument() {
      return this.value.nom;
    },
    sousType() {
      return this.value.sousType;
    },
    issuTeleservice() {
      return this.value.issuTeleservice;
    },
    dateDocument() {
      return this.value.date;
    },
    dateEffet() {
      return this.value.dateEffet;
    },
    typeDocument() {
      return this.value.type;
    },
    journal() {
      return this.value.journal?.libelle;
    },
  },
};
</script>

<style scoped>
.actions-icons {
  align-self: flex-end;
  margin: 5px;
  justify-self: flex-end !important;
  position: absolute;
  right: 0;
}
</style>
